module["exports"] = [
  "Jr.",
  "Sr.",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "MD",
  "DDS",
  "PhD",
  "DVM",
  "Ing.",
  "Lic.",
  "Dr.",
  "Mtro."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/name/suffix.js
// module id = 1109
// module chunks = 1